<template>
    <div class="allyesAdvWrap">
        <div ref="ad" v-if="ifShow"></div>
    </div>
</template>

<script>
import $ from 'jquery'
import {
    sendScData
} from "@/utils/buriedPoint";
export default {
    name: "advSeal",
    props:['advCode','isDD','ddCode','sendSc', 'current_page', 'banner_belong_area', 'banner_name'],
    data(){
        return{
            advData:[],
            ddData:[],
            ifShow:true
        }
    },
    mounted() {
        let el = this.$refs['ad']
        this.renderAD(el)
    },
    methods:{
        renderAD(el) {
            fetch('https://show.artron.net/g?english='+this.advCode).then(r => r.text()).then(res => {
                let document = {
                    write: text => {
                        el.innerHTML += text
                        this.ifShow = text!=''?true:false
                    }
                }
                eval(res)
                this.switchAdv(el)
            })
        },
        switchAdv(el) {
            let that = this;
            $(function () {
                if (that.sendSc) {
                    $(".allyesAdvWrap a").on("click", function () {
                        sendScData('bannerClick', {
                            current_page: that.current_page,
                            banner_belong_area: that.banner_belong_area,
                            banner_name: that.banner_name,
                            banner_id: that.advCode,
                        });
                    })

                }

               

            })
        }
    }
}
</script>

<style scoped lang="scss">
.allyesSealAdv{position: absolute;right:0;height:45px;overflow: hidden;width:141px;top:50%;margin-top: -23px;
    img{height:45px;width:auto;max-width: none;}
}
</style>